
import { defineComponent } from "vue";

export default defineComponent({
  name: "PathwayBadges",
  props: {
    level: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    percentageCompleted: {
      type: Number,
      default: 0
    }
  }
});
